<template>
    <div class="modal__overlay" @click.self="$emit('click', $event)" v-if="hoods.length > 0">
        <div class="modal">
            <div class="page__wrap">
                <img id="close-modal" src="static/close-modal.png" alt="Close Modal"  @click.self="$emit('click', $event)"/>
                <div class="slider__wrap">
                    <swiper :options="swiperOption" class="cooker-flow" ref="mySwiper">
                        <swiper-slide v-for="hood in hoods" :key="hood.id" class="cooker-flow__entry">
                            <img :src="hoodImage(hood)"/>
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                    <div class="swiper-pagination" slot="pagination"></div>
                </div>
                <h3 class="swiper__h3">{{ (hoods[currentSlide]||{title:""}).title }}</h3>
                <p class="sku-tag"><span>SKU:</span> {{hoods[currentSlide].sku}}</p>
                <div class="introduction" v-html="hoods[currentSlide].introduction">
                </div>
                <div class="info__colours">
                    <div class="colour-wrap">
                        <div 
                        class="colour-blob"
                        v-for="(variation, idx) in hoods[currentSlide].colours"
                        :key="idx"
                        @click="setVariation(idx)"
                        :class="{__selected: selectedVariation == idx}"
                        :style="{ 
                            backgroundColor: '#' + variation.colorCode, 
                            color: (useWhiteText(variation.colorCode) ? '#FFFFFF' : '#000000') 
                        }">
                        <span>{{ variation.lbl }}</span>
                        </div>
                    </div>
                </div>
                <div class="key-details">
                    <div class="key-points">
                        <ul>
                            <li v-for="(point, idx) in hoods[currentSlide].keyPoints" :key="idx">{{ point }}</li>
                        </ul>
                    </div>
                    <button @click="toggleShowMore" v-show="!showMoreButton" class="read-more">Read More</button>
                    <transition name="fade">
                    <div v-show="showMoreButton" class="details" v-html="hoods[currentSlide].description">
                    </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {getDatabase} from '../../api/index';
import { useWhiteText } from "../../api/contrastCheck";
export default {
    props: {
        cooker: { type: String }
    },
    name: "hood-modal",
    methods: {
        useWhiteText,
        hoodImage(hood){
            console.log("hood data", hood);
            return 'cache/hoods/'  + hood.id + '/' + hood.colours[ (this.hoods[this.currentSlide].id == hood.id ? this.selectedVariation : 0) ].lbl.replace(" ", "_") + '.jpg'
        },
        toggleShowMore(){
            this.showMoreButton = !this.showMoreButton;
        },
        setVariation(selectedVariation){
            this.selectedVariation = selectedVariation;
        }
    },
    data: function(){
        return {
            hoods: [],
            selectedVariation: 0,
            currentSlide: 0,
            swiperOption: {
                slidesPerView: 3,
                spaceBetween: 60,
                centeredSlides: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 10
                    },
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    }
                },
                on: {
                    slideChange: ()=>{
                        this.currentSlide = this.$refs.mySwiper.swiper.activeIndex;
                        this.selectedVariation = 0;
                    }
                }
            },
            showMoreButton: false

        }
    },
    mounted(){
        getDatabase()
        .getCookerHoodsFor(this.cooker)
        .then( data => {
            console.log("DATA", data);
            this.hoods = data
        });

    }
};
</script>


// WEBPACK FOOTER //
// src/components/ui/hood-modal.vue